import { render, staticRenderFns } from "./flagged-costs-form-corrections.vue?vue&type=template&id=7cddb8cb"
import script from "./flagged-costs-form-corrections.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-form-corrections.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-form-corrections.vue?vue&type=style&index=0&id=7cddb8cb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cddb8cb')) {
      api.createRecord('7cddb8cb', component.options)
    } else {
      api.reload('7cddb8cb', component.options)
    }
    module.hot.accept("./flagged-costs-form-corrections.vue?vue&type=template&id=7cddb8cb", function () {
      api.rerender('7cddb8cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-form/flagged-costs-form-corrections.vue"
export default component.exports